module.exports = __webpack_public_path__ + "img/obstacle-puce-rotate.98fc1c18.png";